import React, { useEffect, useState, useRef } from "react";
import MobileTransactionApprovalItems from "./MobileTransactionApprovalItems";
import Api from "../../utils/Api";
import { setBadge } from "../../utils/push";

export default function MobileTransactionApproval(props) {
    const [lookups, setLookups] = useState(null);
    const [items, setItems] = useState([]);
    const transactionListRef = useRef(null);

    useEffect(() => {
        renderData();
    }, []);

    useEffect(() => {
        // The inquiry list is a different subset, so it must not drive the badge.
        if (!props.inquiry) {
            setBadge(items.length);
        }
    }, [items, props.inquiry]);

    async function renderData() {
        const { response: fetchedLookups } = await Api.lookups();
        const transactionItems = await getUnapprovedTransactions(props.inquiry);
        
        setLookups(fetchedLookups);
        setItems(transactionItems);
        
        if (transactionListRef.current) {
            transactionListRef.current.setLookups(fetchedLookups);
            transactionListRef.current.setItems(transactionItems);
        }
    }

    const getUnapprovedTransactions = async (inquiryOnly) => {
        if (!!inquiryOnly) {
            const {
                response: { items }
            } = await Api.getTransactionInquiry();
            return items;
        } else {
            const {
                response: { items }
            } = await Api.getUnapprovedTransactions();
            return items;
        }
    };

    const removeTransactionCallback = (id) => {
        setItems(prevItems => prevItems.filter(i => i.id !== id));
        if (transactionListRef.current) {
            transactionListRef.current.removeTransaction(id);
        }
    }

    return (
        <MobileTransactionApprovalItems
            approvalMode={true}
            ref={transactionListRef}
            removeTransactionCallback={removeTransactionCallback}
        />
    );
}
